export function formatCurrency(number: number, locale: string = 'en-US') {
  return new Intl.NumberFormat(locale, { style: 'currency', currency: 'USD' }).format(number);
}

export function formatCurrencyWithoutSymbol(number: number, locale: string = 'en-US') {
  return new Intl.NumberFormat(locale).format(number);
}
